module.exports = __webpack_public_path__ + "sketch.png?c2328214b095be9d721dac3cae359636";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sketch.png
// module id = 9
// module chunks = 0